import React from 'react'
let Loading = React.memo(({ label = 'Wird geladen…' }) => {
  return (
    <div role="status" aria-live="polite" style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 24, background: '#fafaf7', color: '#6b6862', fontFamily: 'Inter, sans-serif' }}>
      <span style={{ display: 'grid', justifyItems: 'center', gap: 12 }}>
        <svg className="spinner z-10" aria-hidden="true" width="48" height="48" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
        <span style={{ fontSize: 13, fontWeight: 600 }}>{label}</span>
      </span>
    </div>
  )
})
export default Loading
